export type TextLeadField = "name" | "phone" | "email" | "course" | "notes";
export type SelectLeadField = "stage" | "priority";

// `value` é a chave persistida (não mudar — usada em filtros/DB); `label` é só o
// texto exibido, com acentuação correta.
const PRIORITY_LABELS: Record<string, string> = { Alta: "Alta", Media: "Média", Baixa: "Baixa" };
export const priorityOptions = ["Alta", "Media", "Baixa"].map((value) => ({
  value,
  label: PRIORITY_LABELS[value] || value,
}));
